<template>
  	<div class="mb-5">
		<app-button
			v-if="$route.name === 'diagnoses'"
			class="new-poll"
			text="Nuevo"
			@click="goTo('new-diagnosis')"
		/>
		<div v-if="$route.name === 'diagnoses'">
			<v-layout wrap>
				<v-flex xs12 mt-4 mb-5>
					<app-table
						title="INFORME DE RESULTADOS"
						:filter-columns="false"
						:rows="rows"
						:columns="columns"
						:items-quantity="7"
						:items-total-quantity="totalItems"
						:current-page="currentPage"
						:last-page="lastPage"
						class="is-not-selectable no-main-list"
						@on-page="changePage"
						@on-search-event="onSearch"
						@changeSort="changeSort"
						@changeColor="changeColor"
					>
						<template slot="rows" slot-scope="props">
							<td style="width: 21%;" v-show="showRow(columns, 1)" class="is-not-selectable border-top text-left">{{ props.row.name }}</td>
							<td v-show="showRow(columns, 2)" class="is-not-selectable border-top text-left">{{ props.row.toolName }}</td>
							<td v-show="showRow(columns, 3)" class="border-top">{{props.row.numAnswered}}/{{props.row.numApplicants}}</td>
							<td v-show="showRow(columns, 4)" class="border-top dates">{{ props.row.startDate | formatDate }}</td>
							<td v-show="showRow(columns, 5)" class="border-top dates">{{ props.row.endDate | formatDate }}</td>
							<td v-show="showRow(columns, 6)" class="border-top">
								<app-tooltip-button
									icon="remove_red_eye"
									size="20"
									text="Detalle"
									color="primary"
									@click-icon="goToDetail(props.row)"
								/>
							</td>
						</template>
					</app-table>
				</v-flex>
			</v-layout>
		</div>
		<div v-else>
			<router-view></router-view>
		</div>
  </div>
</template>
<script>
import appButton from '@/components/shared/app-button';

function created() {
	if (this.$route.name === 'diagnoses') {
		this.loadData();
	}
}

async function loadData() {
	const params = {
		...this.params,
		search: this.search || null,
	};
	try {
		const { data: response, headers } = await this.$httpPraktiko.get('diagnostic', { params });
		this.rows = response;
		this.lastPage = Number(headers['x-last-page']);
		this.totalItems = Number(headers['x-quantity']);
	} catch (error) {
		this.showGenericError();
	}
}

function changeColor(fieldName) {
	this.columns.forEach((c, index) => {
		if (c.fieldName !== fieldName && c.color) {
			this.$set(this.columns, index, { ...c, color: 'gray' });
		}
	});
}

function changeSort({ fieldName, sortDirection }) {
	this.params.sortField = fieldName;
	this.params.sortDirection = sortDirection;
	this.loadData();
}

function onSearch(searchVal) {
	const newSearch = searchVal ? searchVal.trim() : null;
	this.search = newSearch;
	this.changePage(1);
	this.loadData();
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData();
}

function goToDetail({ detail, id }) {
	const { toolId } = detail[0];
	this.goTo('detail-diagnoses', { params: { toolId, id } });
}

function data() {
	return {
		columns: [
			{
				id: 1,
				name: 'Resultados de Diagnóstico',
				visible: true,
				checked: true,
				sortCheck: true,
				fieldName: 'name',
				color: 'gray',
			},
			{ id: 2, name: 'Herramienta', visible: true, checked: true },
			{ id: 3, name: 'Aplicantes', visible: true, checked: true },
			{ id: 4, name: 'Fecha Inicial', visible: true, checked: true },
			{ id: 5, name: 'Fecha Final', visible: true, checked: true },
			{ id: 6, name: 'Acciones', visible: true, checked: true },
		],
		rows: [],
		search: null,
		params: {
			page: 1,
			limit: 20,
		},
		lastPage: 0,
		totalItems: 0,
		currentPage: 1,
	};
}

export default {
	name: 'page-diagnosis-diagnoses',
	data,
	created,
	components: {
		appButton,
	},
	methods: {
		loadData,
		onSearch,
		changePage,
		goToDetail,
		changeColor,
		changeSort,
	},
	watch: {
		$route(newVal) {
			if (newVal.name === 'diagnoses') {
				this.loadData();
			}
		},
	},
};
</script>
<style lang="scss">
.diagnosis-diagnoses {
  .text-left {
		margin-bottom: 0px;
		text-align: left;
	}

	.table-list {
		thead tr:nth-child(2) {
			& th:nth-child(2) {
				text-align: left !important;
			}
		}
	}
}
</style>
<style lang="scss" scoped>
.new-poll {
	border-radius: 6px;
	color: white;
	padding: 7px 17px;
}

.dates {
	white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/diagnosis/page-diagnosis-diagnoses.vue